//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PisaPE",
  data() {
    return {
      form: {
        sex: "0",
        age: "0",
        cardiovascular: "0",
        lungs: "0",
        thrombus: "0",
        breathe: "0",
        chestPain: "0",
        hemoptysis: "0",
        heating:'0',
        ecg:'0',
        bloodFlow:'0',
        hilarArtery:'0',
        infarction:'0',
        noinfarction:'0',
        pulmonaryEdema:'0',
        constant:'0'
      },
      hasScore: false,
      disabled: false,
      dataList:[
        { value: "0.59", name: "63-72" },
        { value: "0.92", name: "≥73" },
      ]
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      console.log(form,'form');
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // diabetes + hypertension + ageOver60 + clinic + duration  + (dual ? 2 : 0) + (mri ? 2 : 0) + (stenosis ? 2 : 0)
        let result =
          ((form.sex ? 0.81 : 0) +
          form.age +
          (form.cardiovascular ?-0.56 : 0 ) +
          (form.lungs ? -0.97 : 0) +
          (form.thrombus ? 0.69 : 0) + 
          (form.breathe ? 1.29 : 0) + 
          (form.chestPain ? 0.64 : 0) +
          (form.hemoptysis ? 0.89 : 0) + 
          (form.heating ? -1.17 : 0) + 
          (form.ecg ? 1.53 : 0) + 
          (form.bloodFlow ? 3.86 : 0) + 
          (form.hilarArtery ? 3.92 : 0) + 
          (form.infarction ? 3.55 : 0) + 
          (form.noinfarction ? -1.23 : 0) + 
          (form.pulmonaryEdema ? -2.83 : 0) + 
          (form.constant ? -3.26 : 0)).toFixed(2)
          ;
          let answer = (1 / (1 + Math.exp(result))).toFixed(0) * 100

        self.hasScore = true;
        return {
          result:String(result),
          rate:answer
        };
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/PisaPE.vue